import * as React from 'react';
import cx from 'classnames';

import './error-text.styles.scss';

export type ErrorTextProps = React.PropsWithChildren<{
  text?: React.ReactNode;
  withTopGap?: boolean;
}> & React.HTMLAttributes<HTMLParagraphElement>;

export const ErrorText: React.FC<ErrorTextProps> = (props) => {
  const { children, className, withTopGap, text, ...otherProps } = props;

  return (
    <p 
      title={(typeof text === 'string' || typeof text === 'number') ? text.toString() : undefined}
      className={cx('ErrorText', { 'ErrorText--with-top-gap': withTopGap },  className)}
      {...otherProps}
    >
      {text || children}
    </p>
  );
};